import React, { Component } from "react";
import PropTypes from "prop-types";

import { Translate } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";
import RadioCheck from "./RadioCheck";

import "../../../styles/components/utils/components/ChoiceModal.scss";

class ChoiceModal extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      choices: [],
    };

    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnChoose = this.handleOnChoose.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.hasOwnProperty("choices") && this.props.hasOwnProperty("choices")) {
      if (prevProps.choices !== this.props.choices) {
        this.safeSetState({
          choices: this.props.choices.map((c, idx) => Object.assign({}, c, { checked: idx === 0 })),
        });
      }
    }
  }


  componentWillUnmount() {
    this._mounted = false;
  }

  handleOnChange(e) {
    const idx = this.state.choices.findIndex(c => c.name === e.target.name);
    if (idx !== -1)
      this.safeSetState(prevState => ({
        choices: prevState.choices.map((c, i) => Object.assign({}, c, { checked: idx === i })),
      }));
  }

  handleOnChoose(e) {
    const idx = this.state.choices.findIndex(c => c.checked);
    this.props.onChoose(idx, this.state.choices?.[idx]);
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  renderModalButton() {
    const footerBtn = (
      <button type="button" onClick={this.handleOnChoose}>
        <Translate value={this.props.chooseBtnLabel || this.props.chooseBtnContent} />
      </button>
    );

    if (this.props.hasOwnProperty("btnWrapper") && typeof this.props.btnWrapper === "function") {
      return this.props.btnWrapper(
        footerBtn,
        this.state.choices.find(c => c.checked),
        this.state.choices
      );
    } else {
      return footerBtn;
    }
  }

  render() {
    return (
      <Modal id="choiceModal" show={this.props.show} onHide={this.props.onHide} centered>
        <Modal.Body>
          <div className="choice-container">
            {this.state.choices.map(c => {
              return (
                <RadioCheck
                  key={c.name}
                  label={c.hasOwnProperty("label") ? <Translate value={c.label} /> : c.content}
                  labelPos="right"
                  name={c.name}
                  checked={c.checked}
                  onChange={c.handleOnChange || this.handleOnChange}
                  disabled={c.disabled}
                />
              );
            })}
          </div>
        </Modal.Body>
        <Modal.Footer>{this.renderModalButton()}</Modal.Footer>
      </Modal>
    );
  }
}

ChoiceModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  choices: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        checked: PropTypes.bool.isRequired,
        onChange: PropTypes.func,
        chooseBtnLabel: PropTypes.string.isRequired,
        onChoose: PropTypes.func.isRequired,

      }),
      PropTypes.shape({
        content: PropTypes.any.isRequired,
        name: PropTypes.string.isRequired,
        checked: PropTypes.bool.isRequired,
        onChange: PropTypes.func,
        chooseBtnContent: PropTypes.any.isRequired,
        onChoose: PropTypes.func.isRequired,
      }),
      PropTypes.shape({
        content: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }),
    ])
  ).isRequired,
};

export default ChoiceModal;
